export const fieldRules = [[],[],[],[],[],[],[],
    [
        true,
        true,
        true,
        (value) => (value == 0 || value == 1 || value == 2 || value == 3 || value == 4) || 'type 0, 1, 2, 3, or 4',
        (value) => (value >= 0 && value <= 99) || 'value should be 0-99',
        (value) => (value >= 0 && value <= 99) || 'value should be 0-99',
        (value) => (value >= 0 && value <= 50) || 'value should be 0-50',
        true,
        true,
        true,
        true,
        true,
    ],[true,true,true,true,true]
]